const messages = {
  title: "Erreur interne",
  description: "Les données de cette page n'ont pas pu être chargées correctement.",
  backHomeButton: "Retour au tableau de bord",
}

export default {
  messages
}
